export default __webpack_public_path__ + "static/media/logo.b3cc9d93.jpeg";